module.exports = __webpack_public_path__ + "assets/img/user_m.5b347157.svg";